/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    SAVE: 'Save',
    SUBMIT: 'Submit'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Error canceling counterpart',
    COUNTERPART_DETAILS_SUBMIT: 'Error submitting counterpart',
    DELETE_ATTACHMENT: 'Error deleting attachment',
    DELETE_LINK: 'Error deleting link',
    ERROR: 'Error',
    FILE_SIZE: 'The file cannot be larger than 8Mb',
    MAX_FILES_UPLOAD: 'You can not upload more than 8MB at a time',
    PUBLISHED_AT_ERROR: 'Publication date is required'
  },
  HEADER: {
    APPROVED_BY: 'Approved by',
    ATTACHMENT: 'Attachments',
    COMMENT: 'Comment',
    CONFIRMATION_DATE: 'Confirmation',
    CURRENT_PARTNER_TASKS: 'Curr. P.',
    DESCRIPTION: 'Description',
    END_DATE: 'End date',
    LINK: 'Links',
    MANAGER_COMMENT: 'Manager comment',
    MONTH: 'Month',
    PERIODICITY: 'Periodicity',
    PREVIOUS_PARTNER_TASKS: 'Prev. P.',
    REQUIRED: 'Required',
    START_DATE: 'Start date',
    STATE: 'State',
    SUBMISSION_DATE: 'Submission'
  },
  LABEL: {
    ATTACHMENTS: 'Attachments',
    ATTACHMENTS_UPLOADED: 'Attachments uploaded',
    CANCEL_COUNTERPART: 'Cancel',
    CLOSE: 'Close',
    COMMENT: 'Comment',
    CONFIRM: 'Confirm',
    DESCRIPTION: 'Description',
    FILTER_MONTH_APR: 'April',
    FILTER_MONTH_AUG: 'August',
    FILTER_MONTH_DEC: 'December',
    FILTER_MONTH_FEB: 'February',
    FILTER_MONTH_JAN: 'January',
    FILTER_MONTH_JUL: 'July',
    FILTER_MONTH_JUN: 'June',
    FILTER_MONTH_MAR: 'March',
    FILTER_MONTH_MAY: 'May',
    FILTER_MONTH_NOV: 'November',
    FILTER_MONTH_OCT: 'October',
    FILTER_MONTH_SEP: 'September',
    LINK: 'Link',
    LINKS: 'Links',
    LINKS_UPLOADED: 'Links uploaded',
    MONTH: 'Month',
    PUBLISHED_AT: 'Publication date',
    STATE: 'Status',
    SUBMIT_COUNTERPART: 'Submit',
    YEAR: 'Year'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Are you sure you want to cancel the counterpart submission?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Are you sure you want to submit the counterpart?',
    NO_ROWS_ATTACHMENT: 'No attachments'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Attachment deleted',
    CANCEL_COUNTERPART: 'Counterpart canceled',
    COUNTERPART_DETAILS_SUBMIT: 'Counterpart details successfully submitted',
    LINK_DELETED: 'Link deleted',
    SUCCESS: 'Success'
  },
  TOOLTIP: {
    ADD_LINK: 'Add link',
    APPROVED_BY: 'Approved by',
    ATTACHMENT: 'Attachments',
    COMMENT: 'Comment',
    CONFIRMATION_DATE: 'Confirmation date',
    CURRENT_PARTNER_TASKS:
      'No. of records from the current period to be submitted by the partner',
    DESCRIPTION: 'Description',
    END_DATE: 'End date',
    LINK: 'Links',
    MANAGER_COMMENT: 'Manager comment',
    MONTH: 'Month',
    PERIODICITY: 'Periodicity',
    PREVIOUS_PARTNER_TASKS:
      'No. of records from the previous period to be submitted by the partner',
    REMOVE_LINK: 'Remove Link',
    REQUIRED: 'Required',
    START_DATE: 'Start date',
    STATE: 'Status',
    SUBMISSION_DATE: 'Submission date'
  }
};
